<template>
  <div class="profile-header-nav-top">
    <b-navbar class="px-0" toggleable="lg" type="light">
      <b-navbar-toggle class="ml-auto d-none" target="nav-text-collapse">
        <feather-icon icon="AlignJustifyIcon" size="21" />
      </b-navbar-toggle>

      <b-collapse id="nav-text-collapse" is-nav>
        <b-tabs pills class="mt-1 mt-md-0 d-xl-flex d-none" nav-class="mb-0">
          <template #tabs-start>
            <b-nav-item
              role="presentation"
              :to="{ name: 'profile-road-map' }"
              :active="
                $route.name === 'profile-road-map' ||
                $route.name === 'users-profile-road-map'
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              class="font-weight-bold"
              link-classes="px-xl-75"
            >
              <span class="d-none d-md-block">مسیر یادگیری</span>
              <feather-icon icon="RssIcon" class="d-block d-md-none" />
            </b-nav-item>
            <!-- <b-nav-item
              role="presentation"
              :to="{ name: 'profile' }"
              :active="
                $route.name === 'profile' || $route.name === 'user-detail'
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              class="font-weight-bold"
            >
              <span class="d-none d-md-block">مشخصات</span>
              <feather-icon icon="RssIcon" class="d-block d-md-none" />
            </b-nav-item> -->

            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              :to="{ name: 'shop' }"
              :exact-active-class="
                $route.path.includes('shop') ? 'bg-info border-info' : ''
              "
              :active="$route.name === 'shop'"
              link-classes="px-xl-75"
            >
              <span class="d-none d-md-block">دوره های آموزشی</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              link-classes="px-xl-75"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-courses' }
                  : { name: 'user-courses', params: { id: $route.params.id } }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-courses' ||
                $route.name === 'user-courses'
              "
            >
              <span class="d-none d-md-block">دوره های من</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              link-classes="px-xl-75"
              :to="
                $route.path.includes('profile')
                  ? { name: 'profile-exercises' }
                  : {
                      name: 'user-exercises',
                      params: { id: $route.params.id },
                    }
              "
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-exercises' ||
                $route.name === 'user-exercises'
              "
            >
              <span class="d-none d-md-block">تمرین ها</span>
              <feather-icon icon="InfoIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              link-classes="px-xl-75"
              :to="{ name: 'profile-paid-items' }"
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-paid-items' ||
                $route.name === 'user-paid-items'
              "
            >
              <span class="d-none d-md-block">فاکتور ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              link-classes="px-xl-75"
              :to="{ name: 'profile-penalties' }"
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-penalties' ||
                $route.name === 'user-penalties'
              "
            >
              <span class="d-none d-md-block">جریمه ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
            <b-nav-item
              role="presentation"
              class="font-weight-bold"
              link-classes="px-xl-75"
              :to="{ name: 'profile-transactions' }"
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-transactions' ||
                $route.name === 'user-transactions'
              "
            >
              <span class="d-none d-md-block">تراکنش ها</span>
              <feather-icon icon="UsersIcon" class="d-block d-md-none" />
            </b-nav-item>
          </template>

          <template #tabs-end>
            <b-nav-item
              role="presentation"
              class="font-weight-bold ml-auto"
              link-classes="pl-75 pr-0"
              :to="{ name: 'profile-edit' }"
              :exact-active-class="
                $route.path.includes('users') ? 'bg-info border-info' : ''
              "
              :active="
                $route.name === 'profile-edit' || $route.name === 'user-edit'
              "
            >
              <feather-icon icon="EditIcon" class="d-block d-md-none" />
              <span class="font-weight-bold d-none d-md-block"
                >ویرایش مشخصات</span
              >
            </b-nav-item>
          </template>
        </b-tabs>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import {
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BNavItem,
  BButton,
} from "bootstrap-vue";
export default {
  components: {
    BTabs,
    BButton,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
  },
};
</script>
